import { Component, input, output } from '@angular/core';

export type MbpButtonType = 'primary' | 'secondary' | 'error';

@Component({
  selector: 'mbp-button',
  templateUrl: './mbp-button.component.html',
  styleUrl: './mbp-button.component.scss',
  imports: []
})
export class MbpButtonComponent {
  type = input<MbpButtonType>('primary');
  text = input.required<string>();
  svg = input<string | undefined>(undefined);
  disabled = input<boolean>(false);
  fullWidth = input<boolean>(false);

  buttonClick = output<void>();

  protected onClick(): void {
    this.buttonClick.emit();
  }
}
